export interface RemoteChargingSessionsStatistics {
  dateStart: string;
  dateEnd: string;
  totalChargedEnergy: number; //kwH
  totalChargingDuration: number; //minutes
  hasMIDorME: boolean;
  totalActiveTransactions: number;
}
